import { SupportedMessageFormats, MessageChannelsIdToChannel } from "../../../Contracts";
export const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: (payload, id) => {
        return {
            channel: id || MessageChannelsIdToChannel[payload.id],
            result: payload.result
        };
    }
};
export function ResponseFormatter(type, payload, id) {
    return formats[type](JSON.parse(payload.data), id);
}
//# sourceMappingURL=ResponseFormatter.js.map